import { Role } from '@deltek/specification-client/core/Configurations/Authorization'
import PageRouteConfiguration from '@deltek/specification-client/core/Configurations/PageRouteConfiguration'
import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import React from 'react'

export interface MainPageRoutingProps {
    routes: RouteDictionary
    userRoles: Role[]
    sidebarOpen?: boolean
}

/**
 * This component contains top-level route configurations.
 * Nested routes will be defined within their respective parent components.
 */
const MainPageRouting: React.FC<{
    routes: RouteDictionary
    userRoles: string[]
}> = ({ routes, userRoles }) => {
    return <PageRouteConfiguration routes={routes} userRoles={userRoles} />
}

export default MainPageRouting
